<template>
  <router-link :to="url">
    <button :class="['btn-base', colorClass]">
      {{ text }}
    </button>
  </router-link>
</template>

<script>
export default {
  name: 'ButtonLink',
  props: {
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'black',
      validator(value) {
        return ['yellow', 'black', 'white', 'transparent', 'white-yellow', 'black-white', 'trans-yellow', 'white-trans-yellow-black'].includes(value)
      }
    }
  },
  computed: {
    colorClass() {
      return `btn-${this.color}`
    }
  }
}
</script>

<style scoped>
.btn-base {
  @apply uppercase font-normal py-3 px-6 border border-black transition-colors duration-300 ease-in-out;
}

.btn-yellow {
  background-color: var(--empire-yellow);
  @apply text-black;
}

.btn-yellow:hover {
  filter: brightness(0.95);
}

.btn-black {
  @apply bg-black text-white hover:bg-white hover:text-black;
}

.btn-white {
  @apply bg-white text-black;
}

.btn-white:hover {
  background-color: var(--empire-yellow);
}

.btn-transparent {
  @apply bg-transparent text-black hover:bg-black hover:text-white;
}

/* New color variants */
.btn-white-yellow {
  @apply bg-white text-black;
}

.btn-white-yellow:hover {
  background-color: var(--empire-yellow);
}

.btn-black-white {
  @apply bg-black text-white;
}

.btn-black-white:hover {
  @apply bg-white text-black;
}

.btn-trans-yellow {
  @apply bg-transparent text-black;
}

.btn-trans-yellow:hover {
  background-color: var(--empire-yellow);
}

/* New variant */
.btn-white-trans-yellow-black {
  @apply bg-transparent text-white border-white;
}

.btn-white-trans-yellow-black:hover {
  background-color: var(--empire-yellow);
  @apply text-black border-black;
}
</style> 